/* eslint-disable react/no-array-index-key */
import styled from '@emotion/styled'
import * as React from 'react'

import { Space } from '../../atoms'

const StyledTabHeader = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: solid 1px var(--White90);
  color: var(--Graphite);
  background-color: var(--Transparent);
  width: fill-available;

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    width: fill-available;
  }
  ul > li {
    margin: 0 24px 0 0;
    padding: 0;
    list-style: none;
    flex-direction: column;
    &:last-child {
      margin: 0;
    }
  }
`

export type TabStripProps = {
  children: React.ReactNode[] | React.ReactNode
  suppressPadding?: boolean
}

export const TabStrip = ({ children, suppressPadding }: TabStripProps) => {
  const childrenElems = Array.isArray(children) ? children : [children]

  return (
    <StyledTabHeader>
      <Space pt={suppressPadding ? 0 : 6} px={suppressPadding ? 0 : 5}>
        <ul>
          {childrenElems.map((child, i) => {
            if (child) {
              return <li key={i}>{child}</li>
            }

            return <React.Fragment key={i} />
          })}
        </ul>
      </Space>
    </StyledTabHeader>
  )
}
